export default "__VITE_ASSET__B8N4ShIX__"